import React from 'react';
import { Grid, Card, CardContent, Typography, CircularProgress } from '@material-ui/core';
import { ResponsiveBar } from '@nivo/bar';
import { useSwaggerClient } from '../../../../hooks/useSwaggerClient';

const ActivitiesChart = ({ agentId, fromDate, toDate, dateType, status }) => {
    const [dashboardData, loading] = useSwaggerClient(
        'users/statistics',
        'getAgentActivityDashboard',
        {
            agentId,
            fromDate,
            toDate,
            dateType,
            status
        },
        [agentId, fromDate, toDate, dateType, status]
    );

    const activities = dashboardData?.activities || [];

    if (loading) {
        return (
            <Grid item xs={12}>
                <Card>
                    <CardContent style={{ textAlign: 'center', padding: '40px' }}>
                        <CircularProgress />
                    </CardContent>
                </Card>
            </Grid>
        );
    }

    if (activities.length === 0) {
        return null;
    }

    // Prepare data for the chart
    const chartData = activities.map(activity => ({
        activity:
            activity.activityName.length > 20
                ? activity.activityName.substring(0, 20) + '...'
                : activity.activityName,
        Confirmed: activity.confirmed,
        Unconfirmed: activity.unconfirmed,
        Cancelled: activity.cancelled
    }));

    return (
        <Grid item xs={12}>
            <Card>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        Activities
                    </Typography>
                    <div style={{ height: '450px' }}>
                        <ResponsiveBar
                            data={chartData}
                            keys={['Confirmed', 'Unconfirmed', 'Cancelled']}
                            indexBy="activity"
                            margin={{ top: 20, right: 20, bottom: 80, left: 60 }}
                            padding={0.3}
                            valueScale={{ type: 'linear' }}
                            indexScale={{ type: 'band', round: true }}
                            colors={({ id }) => {
                                const colorMap = {
                                    Confirmed: '#4caf50',
                                    Unconfirmed: '#ff9800',
                                    Cancelled: '#f44336'
                                };
                                return colorMap[id] || '#999';
                            }}
                            borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                            axisTop={null}
                            axisRight={null}
                            axisBottom={{
                                tickSize: 5,
                                tickPadding: 5,
                                legendPosition: 'middle',
                                legendOffset: 50
                            }}
                            axisLeft={{
                                tickSize: 5,
                                tickPadding: 5,
                                tickRotation: 0,
                                legend: 'Vouchers',
                                legendPosition: 'middle',
                                legendOffset: -50,
                                format: v => (v % 1 === 0 ? v : '')
                            }}
                            labelSkipWidth={12}
                            labelSkipHeight={12}
                            labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                            legends={[
                                {
                                    dataFrom: 'keys',
                                    anchor: 'bottom',
                                    direction: 'row',
                                    justify: false,
                                    translateX: 0,
                                    translateY: 70,
                                    itemsSpacing: 10,
                                    itemWidth: 100,
                                    itemHeight: 20,
                                    itemDirection: 'left-to-right',
                                    itemOpacity: 0.85,
                                    symbolSize: 16,
                                    effects: [
                                        {
                                            on: 'hover',
                                            style: {
                                                itemOpacity: 1
                                            }
                                        }
                                    ]
                                }
                            ]}
                            animate={true}
                            motionStiffness={90}
                            motionDamping={15}
                        />
                    </div>
                </CardContent>
            </Card>
        </Grid>
    );
};

export default ActivitiesChart;
